// extracted by mini-css-extract-plugin
export default {"footerArea":"layouts_footerArea__7FIP6"};